import React from "react";
import {
  Box,
  Chip,
  Stack,
  Typography,
} from "@mui/material";
import AccountCircleRoundedIcon from "@mui/icons-material/AccountCircleRounded";
import ShareRoundedIcon from "@mui/icons-material/ShareRounded";
import AffiliateSettingsCard from "../../components/dashboard/AffiliateSettingsCard";

const BRAND = { orange: "#F35A3A", dark: "#19242F" };

export default function AffiliateNetworkPage() {
  return (
    <Stack spacing={{ xs: 1.75, md: 3 }} sx={{ pb: { xs: 1.5, md: 0 } }}>
      <Stack
        direction={{ xs: "column", md: "row" }}
        alignItems={{ xs: "flex-start", md: "center" }}
        justifyContent="space-between"
        spacing={1.5}
      >
        <Box>
          <Stack direction="row" spacing={1} alignItems="center">
            <ShareRoundedIcon sx={{ color: BRAND.orange }} />
            <Typography variant="h3" sx={{ fontWeight: 950, color: BRAND.dark }}>
              Red de referidos
            </Typography>
          </Stack>
          <Typography sx={{ color: "rgba(25,36,47,.65)", mt: 0.6, maxWidth: 760 }}>
            Tu enlace, tu red y tus comisiones pertenecen a tu cuenta de WebProfit. Podés consultarlos aunque todavía no tengas un proyecto.
          </Typography>
        </Box>
        <Chip
          icon={<AccountCircleRoundedIcon />}
          label="Sección personal de tu cuenta"
          variant="outlined"
          sx={{ fontWeight: 900 }}
        />
      </Stack>

      <AffiliateSettingsCard />
    </Stack>
  );
}
